import qs from 'qs';
import interceptors from '@/api/interceptors';
import { client } from './client';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, password) {
	return client.post('/tunnel/api/public/login', qs.stringify({ type: 'pos', username, password }), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function loginOtp(username, otp_code) {
	return client.post('/tunnel/api/public/login/otp', qs.stringify({ type: 'pos', username, otp_code }), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function loginPin(username, pin_code) {
	return client.post('/tunnel/api/public/login/pin', qs.stringify({ username, pin_code }), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function autoLogin(mid, expired) {
	return client.post('/tunnel/api/public/login/autologinPos', qs.stringify({ mid, expired }), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function loginSSO(params) {
	return client.post('/tunnel/api/public/login/ssoPos', qs.stringify(params), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function getTokenSso() {
	return client.get("tunnel/api/pos/sso/ssoLink");
}

export default {
	login,
	autoLogin,
	loginOtp,
	loginPin,
	loginSSO,
	getTokenSso,
};